import { Template, Component, Attribute } from '@scoutgg/ftw/source/lib'
import { Match } from '../../models'
import template from './quick-sets.jade'
import getState from '../../services/event-state'
@Component('sporty')
@Template(template)
@Attribute('match', Match)

export default class QuickSets extends HTMLElement {
  get state() {
    return getState(this.match)
  }

  get quickSets() {
    return this.state.quickSets
  }

  addQuickSet() {
    this.quickSets.push([0, 0])
    this.render()
  }

  submit() {
    this.state.submit()
  }
}
